import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppState } from "src/app/app.reducer";
import { Store } from "@ngrx/store";
import { map, first, take } from "rxjs/operators";
import {
  GetUserRoles,
  GetUserCapabilites,
  GetUserDetails,
} from "src/app/login/store/auth.actions";

import { SocketService } from "src/app/services/socket.service";
import { GetConfigurations } from "./configurations/store/configurations.actions";
import { GetQuarters } from "./monitoring-evaluation/store/monitoring-evaluation.actions";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent {
  USER_MANAGEMENT = "User Management";
  activeLinkIndex = -1;
  links: Array<any> = [];
  breakFlag: boolean = false;
  selectedPath: string;
  userCapabilities;
  unreadMessageCount;

  private tabs: Array<any> = [
    {
      label: "User Management",
      path: "user-management",
      permission: [
        "activate-deactivate-user",
        "bulk-invite",
        "edit-user-profile",
        "change-user-role",
        "create-user",
        "replace-user",
      ],
    },
    {
      label: "Program Dashboard",
      path: "program-dashboard/project",
      permission: ["view-my-project", "view-all-projects", "manage-project"],
    },
    {
      label: "Document Hub",
      path: "resources",
      permission: ["display-document-menu"],
    },
    // {
    //   label: 'Groups',
    //   path: 'user-groups',
    //   permission: ['all']

    // },
    {
      label: "Tasks",
      path: "tasks",
      permission: ["display-task-menu"],
    },
    {
      label: "Messages",
      path: "messages",
      permission: ["display-message-menu"],
      // inbox: true
    },
    // {
    //     label: "Monitoring & Evaluation",
    //     path: "monitoring-evaluation/project",
    //     permission: ["all"],
    //     // inbox: true
    // },
    {
      label: "Role Management",
      path: "role-management",
      permission: ["display-role-management"],
    },
    {
      label: "Events",
      path: "events/event/event-list",
      permission: ["display-event-menu"],
    },
    {
      label: "Procurement",
      path: "procurement",
      permission: ["display-procurement-menu"],
    },
    {
      label: "Budgeting",
      path: "budget",
      permission: ["display-budget-menu"],
    },
    {
      label: "Challenge",
      // path: "challenge/dashboard/spv-dashboard",
      path: "challenge",
      permission: ["display-challenge-menu"],
    },
  ];
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService
  ) {
    this.socketService.getUnreadMessages().subscribe((data) => {
      this.unreadMessageCount = data;
    });

    this.store.dispatch(new GetUserDetails());
    this.store.dispatch(new GetUserRoles());
    this.store.dispatch(new GetUserCapabilites());
    this.store.dispatch(new GetConfigurations());
    this.store.dispatch(new GetQuarters());
    this.links = Object.assign([], this.tabs);

    this.links.filter((link, i) => (link.index = i));
    this.router.events.subscribe((res) => {
      // if (this.router.url.includes("/home/events/event")) {
      //   const box = document.getElementById("header6");
      //   console.log(box)
      //     box.classList.add("active-tab");
      // }
      // console.log(this.links);
      // console.log(this.router.url);

      if(this.router.url.split("/")[2] == "challenge"){
        localStorage.setItem('isChallengeBanner','yes')
      }else{
        localStorage.setItem('isChallengeBanner','no')
      }


      this.activeLinkIndex = this.links.indexOf(
        this.links.find((tab) => this.router.url.includes(`/home/${tab.path}`))
      );
    });

    if (this.router.url.trim().split("/").length <= 2) {
      this.store
        .select((store) => store.auth.user["capabilities"])
        .pipe(take(2))
        .subscribe((res) => {
          if (res) {
            if (res.length > 0) {
              const allCapabilities = (res || []).reduce((acc, item) => {
                return [...acc, ...item.capabilities];
              }, []);
              if (allCapabilities) {
                for (let i = 0; i < this.tabs.length; i++) {
                  this.breakFlag = false;
                  if (this.tabs[i].permission) {
                    for (let j = 0; j < this.tabs[i].permission.length; j++) {
                      if (
                        allCapabilities.includes(this.tabs[i].permission[j])
                      ) {
                        this.selectedPath = this.tabs[i].path;
                        this.breakFlag = true;
                        break;
                      }
                    }
                  }
                  if (this.breakFlag) {
                    this.router.navigate([`/home/${this.selectedPath}`]);
                    break;
                  }
                }

                if (!this.selectedPath) {
                  this.router.navigate([`/home/resources`]);
                }
              }
            }
          }
        });
    }

    // this.store.select(store => store.auth.user['capabilities']).pipe(take(2)).subscribe(
    //     res => {
    //         this.userCapabilities = res;
    //         this.links.forEach(tab => {
    //             if (this.router.url.includes(`/home/${tab.path}`)) {
    //                 tab.permission.forEach(permission => {
    //                     if (!res[0].capabilities.includes(permission)) {
    //                         this.router.navigate([`/home/resources`])
    //                     }
    //                 });
    //             }
    //         });
    // });
  }
}
